import { DateTime } from "luxon"

type minutesToLargestUnitReturn = {
  unit: 'minutes' | 'hours' | 'days' | 'months'
  value: number
}

export const useTime = () => {
  const calculateTimeDiff = (from: string, to?: string): number => {
    const fromDate = DateTime.fromISO(from)
    const toDate = to ? DateTime.fromISO(to) : DateTime.now()
    return toDate.diff(fromDate).as('minutes')
  }

  const minutesToLargestUnit = (minutes: number): minutesToLargestUnitReturn => {
    const hours = minutes / 60
    const days = hours / 24
    const months = days / 30

    if (months >= 1) return { value: months, unit: 'months' }
    if (days >= 1) return { value: days, unit: 'days' }
    if (hours >= 1) return { value: hours, unit: 'hours' }
    return { value: minutes, unit: 'minutes' }
  }

  return {
    calculateTimeDiff,
    minutesToLargestUnit,
  }
}
